<template>
  <div class="flex h-[100vh] items-center justify-center">
    <h1>
      Redirect to Mitra Komerce Mobile App
    </h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
